module.exports = __webpack_public_path__ + "img/tengxunsp_p.4f64681d.png";